<div [formGroup]="formGroup" class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
  <siat-select-field
    formControlName="struttura"
    id="id"
    name="name"
    label="{{ 'SANITARIO.strutturaLabel' | translate }}"
    placeholder="{{ 'SANITARIO.strutturaPlaceholder' | translate }}"
    [items]="itemsStrutture()"
  ></siat-select-field>

  <siat-select-field
    formControlName="ruolo"
    id="id"
    name="name"
    label="{{ 'SANITARIO.ruoloLabel' | translate }}"
    placeholder="{{ 'SANITARIO.ruoloPlaceholder' | translate }}"
    [items]="itemsRuoli()"
  ></siat-select-field>
</div>
